// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ssn-size[data-v-70f3035c] {\n  min-width: 115px;\n}\n@media only screen and (max-width: 768px) {\nspan[data-v-70f3035c],\n  p[data-v-70f3035c] {\n    font-size: 12px !important;\n}\n}", ""]);
// Exports
module.exports = exports;
